import React, { useState, useEffect } from "react";
import {
  Col,
  Row,
  Button,
  Badge,
  Card,
  Alert,
  Form,
  InputGroup,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExclamationCircle,
  faEdit,
  faPlus,
  faFile,
  faAddressCard,
  faPen,
  faTrashAlt,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { IbsTable } from "../../components/Tables";
import LoadingComponent from "../../components/LoadingComponent";
import { useModalWrapper } from "../../components/ModalWrapperProvider";
import * as yup from "yup";
import { useFormik } from "formik";
import usePrograms from "../../hooks/program.hook";
import { errorToast, successToast } from "../../utils/toast";
import DataTable from "react-data-table-component";
import "./IbPage.scss";
import useIbs from "../../hooks/ib.hook";
import Swal from "sweetalert2";
import Select from "react-select";
import useReport from "../../hooks/report.hook";
import ALL_MONTHS from "../../utils/constValues";
import CopyField from "../components/CopyField";

const crypto = require("crypto");

function GenerateBatchReportsModal(props) {
  const current_date = new Date();
  const [loading, setLoading] = useState(false);
  const { getAllReports } = useReport();

  const dateSchema = yup.object({
    tx_month: yup
      .number()
      .required("Debes especificar el mes de los reportes a generar")
      .min(1)
      .max(12),
    tx_year: yup
      .number()
      .required("Debes especificar el año de los reportes a generar")
      .min(2000, "El archivo de operativa debe ser del año 2000 o más tarde"),
  });

  const formikFileDate = useFormik({
    initialValues: {
      tx_month: current_date.getMonth() + 1,
      tx_year: current_date.getFullYear(),
    },
    validationSchema: dateSchema,
    onSubmit: (values) => {
      setLoading(true);
      getAllReports(values.tx_month, values.tx_year)
        .then((successStream_filename) => {
          setLoading(false);
          props.closeItselfCallback();
          successToast("¡Se ha creado los reportes con exito!");
        })
        .catch((error) => {
          setLoading(false);
          props.closeItselfCallback();
          errorToast(error);
        });
    },
  });
  const months = ALL_MONTHS;
  return (
    <>
      <Row className="justify-content-center">
        <Col xs={12}>
          <Card>
            {loading && (
              <>
                <LoadingComponent className="d-flex align-items-center justify-content-center"></LoadingComponent>
              </>
            )}
            <Card.Body>
              <Form style={{ padding: "10px" }}>
                <Form.Label>Mes de operaciones</Form.Label>
                <InputGroup>
                  <Select
                    id="filemonth"
                    className="form-control"
                    classNamePrefix="select"
                    defaultValue={months.filter(
                      (monthObj) =>
                        monthObj.value === formikFileDate.values.tx_month
                    )}
                    name="month"
                    onChange={(e) => {
                      formikFileDate.setFieldValue("tx_month", e.value);
                    }}
                    options={months}
                  />
                </InputGroup>
                <Form.Label>Año de operaciones</Form.Label>
                <InputGroup>
                  <Form.Control
                    id="tx_year"
                    type="number"
                    min="2000"
                    max={current_date.getFullYear()}
                    className={` ${
                      formikFileDate.touched.tx_year &&
                      formikFileDate.errors.tx_year
                        ? "invalid"
                        : ""
                    } ${
                      formikFileDate.touched.tx_year &&
                      !formikFileDate.errors.tx_year
                        ? "valid"
                        : ""
                    }`}
                    value={formikFileDate.values.tx_year}
                    onChange={formikFileDate.handleChange}
                    onBlur={formikFileDate.handleBlur}
                  />
                </InputGroup>
              </Form>
            </Card.Body>
            <Card.Footer>
              <Button
                variant="primary"
                type="button"
                className="w-100"
                onClick={(e) => {
                  Swal.fire({
                    title: "¿Estas seguro que ese es el mes?",
                    showCancelButton: true,
                    confirmButtonText: "Generar",
                    cancelButtonText: `Cancelar`,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      formikFileDate.handleSubmit();
                    }
                  });
                }}
              >
                Generar reportes
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </>
  );
}

function CreateProgramModal(props) {
  const [disabled, setDisabled] = useState(true);
  const [all_groups, setAllGroups] = useState(props.overallGroups);
  const [createdProgram, setCreatedProgram] = useState(
    all_groups.reduce((acc, curr) => ((acc[curr] = []), acc), {})
  );
  const [groups, setGroups] = useState([]);
  const all_schemes = props.overallSchemes;
  const [currentGroupSelected, setCurrentGroupSelected] = useState(null);
  /* eslint-disable no-unused-vars */
  const [groupsData, setGroupsData] = useState(null);
  /* eslint-enable no-unused-vars */
  const makeNewGroup = (newGroup) => {
    let _groups = groups;
    _groups.push(newGroup);
    setAllGroups(all_groups.filter((groupName) => groupName !== newGroup));
    setGroups(groups);
  };

  /* eslint-disable no-unused-vars */
  const eraseNewGroup = (oldGroup) => {
    let _groups = groups;
    _groups.push(oldGroup);
    setAllGroups(_groups);
    let _createdProgram = { ...createdProgram };
    _createdProgram[oldGroup] = [];
    setCreatedProgram(_createdProgram);
  };
  /* eslint-enable no-unused-vars */
  const makeNewAgreement = ({
    scheme = "all",
    symbol = null,
    default_lot_size = 1,
    group = null,
    default_market_price = 0,
  }) => {
    let _createdProgram = { ...createdProgram };
    let new_agreement = {
      id: crypto.randomBytes(4).toString("hex"),
      scheme: scheme,
      symbol: symbol,
      default_lot_size: default_lot_size,
      default_market_price: default_market_price,
      group: group,
      created: true,
    };
    _createdProgram[group].push(new_agreement);
    console.log(_createdProgram);
    setCreatedProgram(_createdProgram);
  };
  /* eslint-disable no-unused-vars */
  const deleteNewAgreement = (group, agreementId) => {
    let newProgram = { ...createdProgram };
    let _agreements = createdProgram[group];
    newProgram[group] = _agreements.filter(
      (agreement) => agreement.id !== agreementId
    );
    setCreatedProgram(newProgram);
  };
   /* eslint-enable no-unused-vars */

  const generateTable = (groupName) => {
    const options = all_schemes.map((schemename) => {
      return {
        label: schemename,
        value: schemename,
      };
    });
     /* eslint-disable no-unused-vars */
    const loaded_values = createdProgram[groupName];
    let columns = [
      {
        name: "Schemas",
        selector: (row) => {
          const index_of_row = createdProgram[groupName].findIndex(
            (agreement) => agreement.id === row.id
          );
          const customStyles = {
            container: () => ({
              position: "sticky",
              overflow: "visible",
              width: "100%",
            }),
          };
           /* eslint-enable no-unused-vars */
          return (
            <Select
              id={`groupschemaselectrow${row.id}`}
              className="form-control"
              classNamePrefix="select"
              name={`groupschemaselectrow${row.id}`}
              defaultValue={[
                {
                  label: createdProgram[groupName][index_of_row]["scheme"],
                  value: createdProgram[groupName][index_of_row]["scheme"],
                },
              ]}
              onChange={(e) =>
                changeAgreementHandle(e.value, "scheme", row.id, row.group)
              }
              options={options}
            />
          );
        },
        grow: 1,
        allowOverflow: true,
      },
      {
        name: "Símbolo",
        selector: (row) => {
          const index_of_row = createdProgram[groupName].findIndex(
            (agreement) => agreement.id === row.id
          );
          return (
            <Form.Control
              required
              id={row.id + "symbol"}
              type="text"
              maxLength="128"
              value={
                createdProgram[groupName][index_of_row]["symbol"] === null
                  ? "todos"
                  : createdProgram[groupName][index_of_row]["symbol"]
              }
              placeholder={row.symbol === null ? "todos" : row.symbol}
              onChange={(e) =>
                changeAgreementHandle(
                  e.target.value,
                  "symbol",
                  row.id,
                  row.group
                )
              }
            />
          );
        },
        grow: 1,
      },
      {
        name: "Tamaño de lote",
        selector: (row) => {
          const index_of_row = createdProgram[groupName].findIndex(
            (agreement) => agreement.id === row.id
          );
          return (
            <Form.Control
              required
              id={row.id + "lotsize"}
              type="number"
              step="any"
              min="0"
              value={
                createdProgram[groupName][index_of_row]["default_lot_size"]
              }
              onChange={(e) =>
                changeAgreementHandle(
                  e.target.value,
                  "default_lot_size",
                  row.id,
                  row.group
                )
              }
            />
          );
        },
        grow: 1,
      },
      {
        name: "Pago por Rebate",
        selector: (row) => {
          const index_of_row = createdProgram[groupName].findIndex(
            (agreement) => agreement.id === row.id
          );
          return (
            <Form.Control
              required
              id={row.id + "marketPrice"}
              type="number"
              step="any"
              min="0"
              value={
                createdProgram[groupName][index_of_row]["default_market_price"]
              }
              onChange={(e) =>
                changeAgreementHandle(
                  e.target.value,
                  "default_market_price",
                  row.id,
                  row.group
                )
              }
            />
          );
        },
        grow: 1,
      },
    ];
    return (
      <Row style={{ marginBottom: "10px" }}>
        {createdProgram[groupName].length > 0 && (
          <Col xs="12">
            <DataTable
              key={
                groupName +
                "table" +
                "creation" +
                crypto.randomBytes(4).toString("hex")
              }
              striped
              highlightOnHover
              columns={columns}
              data={createdProgram[groupName]}
            />
            <Col xs="12" style={{ marginTop: "10px" }}>
              <Button
                variant="secondary"
                onClick={(e) => makeNewAgreement({ group: groupName })}
              >
                <FontAwesomeIcon icon={faPlus}></FontAwesomeIcon>
              </Button>
            </Col>
          </Col>
        )}
        {createdProgram[groupName].length === 0 && (
          <Col xs="12">
            <Button
              variant="secondary"
              onClick={(e) => makeNewAgreement({ group: groupName })}
            >
              <FontAwesomeIcon icon={faPlus}></FontAwesomeIcon>
            </Button>
          </Col>
        )}
      </Row>
    );
  };

  useEffect(() => {
    if (createdProgram[currentGroupSelected] !== undefined) {
      console.log("creating tables...");
      setGroupsData(groups.map((groupName) => generateTable(groupName)));
      if (
        Object.values(createdProgram).some(
          (agreements) => agreements.length > 0
        )
      ) {
        setDisabled(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createdProgram, currentGroupSelected, groups]);

  const changeAgreementHandle = (value, field, agreementId, group) => {
    let _createdProgram = { ...createdProgram };
    let agreement_index = _createdProgram[group].findIndex(
      (agreement) => agreement.id === agreementId
    );
    _createdProgram[group][agreement_index][field] = value;
    setCreatedProgram(_createdProgram);
  };
  return (
    <>
      <Row>
        <Col xs={12}>
          `{" "}
          <Card>
            <Card.Header>
              <h5> Crear nuevo grupo</h5>
              <Row className="align-items-center text-center">
                <Col xs={9}>
                  <Select
                    id={"creationOfGroupModal"}
                    options={all_groups.map((groupName) => {
                      return { label: groupName, value: groupName };
                    })}
                    onChange={(e) => {
                      console.log(e.value);
                      setCurrentGroupSelected(e.value);
                    }}
                    className="form-control"
                    name="createOfGroupModalSelect"
                  />
                </Col>
                <Col xs={3}>
                  <Button
                    variant="secondary"
                    onClick={(e) => {
                      makeNewGroup(currentGroupSelected);
                    }}
                  >
                    Agregar grupo de productos
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <>
                {groups.length > 0 &&
                  groups.map((groupName) => {
                    return (
                      <Row
                        key={`${groupName}tablecontainer`}
                        style={{ magrinBotton: "12px" }}
                      >
                        <Col xs="12">
                          <h6>{groupName}</h6>
                        </Col>
                        {generateTable(groupName)}
                      </Row>
                    );
                  })}
              </>
            </Card.Body>
            <Card.Footer>
              <Row className="align-items-center text-center">
                <Col xs={12}>
                  <Button
                    variant={disabled ? "primary" : "secondary"}
                    type="button"
                    className="w-100"
                    disabled={disabled}
                    onClick={(e) => {
                      Swal.fire({
                        title:
                          "¿Estás seguro que esto son los acuerdos y condiciones a crear?",
                        showCancelButton: true,
                        confirmButtonText: "Crear",
                        cancelButtonText: `Cancelar`,
                      }).then((result) => {
                        if (result.isConfirmed) {
                          props.createCallback(Object.values(createdProgram));
                        }
                      });
                    }}
                  >
                    Crear condiciones y acuerdos del afiliado
                  </Button>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
          `
        </Col>
      </Row>
    </>
  );
}

function CreationIbModal({ handleSumbit }) {
  const [disabled, setDisabled] = useState(true);
  const IbSchema = yup.object({
    ib_number: yup
      .string()
      .required("Debes ingresar un número de afiliado")
      .max(11),
    name: yup.string().required("Debes ingresar nombre del afiliado").max(64),
    email: yup
      .string()
      .required("Debes ingresar un correo electrónico")
      .email("Debes ingresar un correo electrónico válido")
      .max(320)
      .matches(
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
        "Por favor ingresa un email válido"
      ),
    account_number: yup
      .string()
      .required("Debes ingresar un número de cuenta del afiliado")
      .max(32),
  });

  const formikIb = useFormik({
    initialValues: {
      ib_number: "",
      name: "",
      email: "",
      account_number: "",
    },
    validationSchema: IbSchema,
    onSubmit: (values) => {
      handleSumbit(values);
    },
  });

  useEffect(() => {
    if (
      Object.keys(formikIb.errors).length === 0 &&
      !Object.values(formikIb.values).some((value) => value === "")
    ) {
      setDisabled(false);
    }
  }, [formikIb.values, formikIb.errors]);

  let content;

  content = (
    <>
      <Row className="justify-content-center">
        <Form onSubmit={formikIb.handleSubmit} style={{ padding: "10px" }}>
          <Form.Group className="mb-4">
            <Form.Label>Nombre</Form.Label>
            <InputGroup>
              <Form.Control
                required
                id="name"
                type="text"
                maxLength="128"
                placeholder="Afiliado vitecap"
                className={` ${
                  formikIb.touched.name && formikIb.errors.name ? "invalid" : ""
                } ${
                  formikIb.touched.name && !formikIb.errors.name ? "valid" : ""
                }`}
                value={formikIb.values.name}
                onChange={formikIb.handleChange}
                onBlur={formikIb.handleBlur}
              />
            </InputGroup>
            {formikIb.touched.name && formikIb.errors.name && (
              <div style={{ position: "absolute", display: "flex" }}>
                <small
                  className="invalid-feedback"
                  style={{ display: "inline-block" }}
                >
                  {" "}
                  <FontAwesomeIcon icon={faExclamationCircle} />{" "}
                  {formikIb.errors.name}
                </small>
              </div>
            )}
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label>Correo electrónico</Form.Label>
            <InputGroup>
              <Form.Control
                required
                id="email"
                type="text"
                maxLength="320"
                placeholder="afiliado@vitecapital.com"
                className={` ${
                  formikIb.touched.email && formikIb.errors.email
                    ? "invalid"
                    : ""
                } ${
                  formikIb.touched.email && !formikIb.errors.email
                    ? "valid"
                    : ""
                }`}
                value={formikIb.values.email}
                onChange={formikIb.handleChange}
                onBlur={formikIb.handleBlur}
              />
            </InputGroup>
            {formikIb.touched.email && formikIb.errors.email && (
              <div style={{ position: "absolute", display: "flex" }}>
                <small
                  className="invalid-feedback"
                  style={{ display: "inline-block" }}
                >
                  {" "}
                  <FontAwesomeIcon icon={faExclamationCircle} />{" "}
                  {formikIb.errors.email}
                </small>
              </div>
            )}
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label>Número de Afiliado</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faAddressCard} />
              </InputGroup.Text>
              <Form.Control
                required
                id="ib_number"
                type="text"
                maxLength="11"
                placeholder="12345678910"
                className={` ${
                  formikIb.touched.ib_number && formikIb.errors.ib_number
                    ? "invalid"
                    : ""
                } ${
                  formikIb.touched.ib_number && !formikIb.errors.ib_number
                    ? "valid"
                    : ""
                }`}
                value={formikIb.values.ib_number}
                onChange={formikIb.handleChange}
                onBlur={formikIb.handleBlur}
              />
            </InputGroup>
            {formikIb.touched.ib_number && formikIb.errors.ib_number && (
              <div style={{ position: "absolute", display: "flex" }}>
                <small
                  className="invalid-feedback"
                  style={{ display: "inline-block" }}
                >
                  {" "}
                  <FontAwesomeIcon icon={faExclamationCircle} />{" "}
                  {formikIb.errors.ib_number}
                </small>
              </div>
            )}
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label>Número de cuenta</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faPen} />
              </InputGroup.Text>
              <Form.Control
                required
                id="account_number"
                type="text"
                maxLength="8"
                placeholder="12345678"
                className={` ${
                  formikIb.touched.account_number &&
                  formikIb.errors.account_number
                    ? "invalid"
                    : ""
                } ${
                  formikIb.touched.account_number &&
                  !formikIb.errors.account_number
                    ? "valid"
                    : ""
                }`}
                value={formikIb.values.account_number}
                onChange={formikIb.handleChange}
                onBlur={formikIb.handleBlur}
              />
            </InputGroup>
            {formikIb.touched.account_number &&
              formikIb.errors.account_number && (
                <div style={{ position: "absolute", display: "flex" }}>
                  <small
                    className="invalid-feedback"
                    style={{ display: "inline-block" }}
                  >
                    {" "}
                    <FontAwesomeIcon icon={faExclamationCircle} />{" "}
                    {formikIb.errors.account_number}
                  </small>
                </div>
              )}
          </Form.Group>
          <Button
            variant="primary"
            type="submit"
            className="w-100"
            disabled={disabled || Object.keys(formikIb.errors).length > 0}
          >
            Crear Afiliado
          </Button>
        </Form>
      </Row>
    </>
  );

  return content;
}

function IbPage() {
  const { modifyIbData, createIb } = useIbs();
  const [selectedIb, setSelectedIb] = useState(null);
  const [isIbDataLoading, setIsIbDataLoading] = useState(false);
  const [isProgramLoading, setIsProgramLoading] = useState(false);
  const [loadedProgram, setLoadedProgram] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const { getProgram, createProgram, modifyProgram } = usePrograms();
  const [overallPrograms, setOverallPrograms] = useState(null);
  const [groupsData, setGroupsData] = useState(null);
  const [wasSearched, setWasSearched] = useState(false);
  const [erasedGroups, setErasedGroups] = useState([]);
  const { showModal, hideModal } = useModalWrapper();

  const handleEditSubmit = () => {
    setIsIbDataLoading(true);
    modifyIbData(Ibformik.values)
      .then((successData) => {
        // here we set the new selectedIb to be the one successful resulting from the operation
        setSelectedIb({
          selectedRows: [successData.ib_modified],
        });
        successToast("Se ha modificado los datos del Afiliado con éxito");
        setIsIbDataLoading(false);
      })
      .catch((error) => {
        // here we reset the data
        setIsIbDataLoading(false);
        errorToast(error);
      });
  };

  const IbSchema = yup.object({
    ib_number: yup.string().max(32),
    firstname: yup.string().max(64),
    lastname: yup.string().max(64),
    email: yup
      .string()
      .email("Debes ingresar un correo electrónico válido")
      .max(320)
      .matches(
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
        "Por favor ingresa un email válido"
      ),
    ib_link: yup.string().max(320),
    // TODO add country selection
    //country: yup.string().max(2),
    account_number: yup.string().max(32),
  });

  const Ibformik = useFormik({
    validationSchema: IbSchema,
    onSubmit: handleEditSubmit,
  });

  const IbdataWasChanged = (currentValues, currentRow) => {
    let there_was_change = [];
    if (currentValues !== undefined && currentRow !== undefined) {
      Object.keys(currentValues).forEach((objectKey) => {
        if (objectKey !== "lastname" && objectKey !== "firstname") {
          there_was_change.push(
            currentValues[objectKey] === currentRow[objectKey]
          );
        } else {
          there_was_change.push(
            currentValues.firstname.toUpperCase() +
              " " +
              currentValues.lastname.toUpperCase() ===
              currentRow.name.toUpperCase()
          );
        }
      });
      return there_was_change.every((check) => check === true);
    } else {
      return !false;
    }
  };

  const saveModifiedProgramForGroup = (
    OverallProgramData,
    erasedGroups = []
  ) => {
    // here we send data on group modified to backend
    setIsProgramLoading(true);
    modifyProgram(OverallProgramData, selectedIb.ib_number, erasedGroups)
      .then((success) => {
        successToast("Haz modificado con exito el programa del usuario!");
        getProgram(selectedIb.ib_number)
          .then((ProgramData) => {
            setLoadedProgram(ProgramData.program);
            setIsProgramLoading(false);
            setErasedGroups([])
          })
          .catch((errorProgram) => {
            errorToast(errorProgram);
            setIsProgramLoading(false);
          });
      })
      .catch((errorProgram) => {
        errorToast(errorProgram);
        setIsProgramLoading(false);
      });
  };

  const changeProgramField = (
    field,
    group,
    programId,
    value,
    erasal = false
  ) => {
    if (erasal) {
      Swal.fire({
        title: "¿Estás seguro que deseas eliminar esta condición?",
        text: "No serás capaz de revertir esto, una vez confirmes al modificar las condiciones y acuerdos",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí",
      }).then((result) => {
        if (result.isConfirmed) {
          setOverallPrograms((previousProgram) => {
            let newProgram = { ...previousProgram };
            newProgram[group][programId][field] = value;
            newProgram[group][programId].modified = true;
            if (erasal) newProgram[group][programId].erased = true;
            return newProgram;
          });
          setLoadedProgram((previousLoadedProgram) => {
            let newProgram = previousLoadedProgram;
            let index =
              previousLoadedProgram.groups[group].programs_ids.indexOf(
                programId
              );
            previousLoadedProgram.groups[group].programs_ids.splice(index, 1);
            previousLoadedProgram.groups[group].default_market_prices.splice(
              index,
              1
            );
            previousLoadedProgram.groups[group].schemes.splice(index, 1);
            previousLoadedProgram.groups[group].default_lot_sizes.splice(
              index,
              1
            );
            try {
              previousLoadedProgram.groups[group].symbols.splice(index, 1);
            } catch {
              //pass
            }
            return newProgram;
          });
          setGroupsData(createGroupsData(changeProgramField));
        }
      });
    } else {
      setOverallPrograms((previousProgram) => {
        let newProgram = { ...previousProgram };
        // we check if it is new
        if (programId[programId.length - 1] === "n" && field === "schema") {
          newProgram[group][programId].selected_scheme = value;
        }
        newProgram[group][programId][field] = value;
        newProgram[group][programId].modified = true;
        return newProgram;
      });
    }
  };

  const sendProgramCreationData = (newProgramData) => {
    hideModal();
    let all_agreements_to_submit = [].concat.apply([], newProgramData);
    setIsProgramLoading(true);
    createProgram(selectedIb.ib_number, all_agreements_to_submit)
      .then((successData) => {
        setIsProgramLoading(false);
        successToast(
          "¡Haz creado exitosamente las condiciones y acuerdos del afiliado!"
        );
        getProgram(selectedIb.ib_number)
          .then((ProgramData) => {
            setIsProgramLoading(false);
            setLoadedProgram(ProgramData.program);
          })
          .catch((errorProgram) => {
            errorToast(errorProgram);
            setIsProgramLoading(false);
          });
      })
      .catch((error) => {
        setIsProgramLoading(false);
        errorToast("¡Ha sucedido un problema por favor intenta de nuevo!");
      });
  };

  const createProgramHandle = () => {
    console.log("Creating program");
    //pass as props loadedProgram.all_groups
    // pass as props loadedProgram.schemes
    showModal({
      title: "Creación de condiciones y acuerdos",
      size: "xl",
      body: (
        <CreateProgramModal
          overallGroups={loadedProgram.all_groups}
          overallSchemes={loadedProgram.schemes}
          createCallback={sendProgramCreationData}
        />
      ),
      buttons: (
        <>
          <Button
            key="1"
            variant="default"
            onClick={cancelCreationButtonHandler}
          >
            {"Cancelar"}
          </Button>
        </>
      ),
    });
  };

  const createNewAgreementHandle = (group) => {
    let new_program = { ...loadedProgram };
    const all_schemes = loadedProgram.schemes.map((scheme) => {
      return { label: scheme, value: scheme };
    });
    new_program.groups[group].schemes.push(all_schemes[0].value);
    new_program.groups[group].default_lot_sizes.push(0);
    new_program.groups[group].default_market_prices.push(0);
    new_program.groups[group].programs_ids.push(
      crypto.randomBytes(3).toString("hex") + "n"
    );
    setLoadedProgram(new_program);
  };

  const eraseGroupFromAgreements = (group) => {
    Swal.fire({
      title: "¿Estás seguro que deseas eliminar este grupo?",
      text: "No serás capaz de revertir esto, una vez confirmes al modificar las condiciones y acuerdos",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí",
    }).then((result) => {
      if (result.isConfirmed) {
        let newProgram = { ...loadedProgram };
        delete newProgram.groups[group];
        setLoadedProgram(newProgram);
        let newErased = [...erasedGroups];
        newErased.push(group);
        setErasedGroups(newErased);
      }
    });
  };

  const createGroupsData = (changeModificationsOnProgramField) => {
    const all_schemes = loadedProgram.schemes.map((scheme) => {
      return { label: scheme, value: scheme };
    });
    let incremental_z_index = 0;
    let initial_z_index = 100;
    let overallProgram = {};
    let result = null;
    if (Object.keys(loadedProgram.groups).length > 0) {
      result = Object.keys(loadedProgram.groups).map((groupName) => {
        let data = Object.values(loadedProgram.groups[groupName].schemes).map(
          (value, index) => {
            let new_row = {
              id: "",
              ib_number: selectedIb.ib_number,
              scheme: "",
              symbol: "",
              default_lot_size: "",
              default_market_price: "",
              group: groupName,
              modified: false,
            };
            new_row.id = index;
            new_row.scheme = value;
            new_row.selected_scheme = { label: value, value: value };
            new_row.default_market_price =
              loadedProgram.groups[groupName].default_market_prices[index];
            new_row.default_lot_size =
              loadedProgram.groups[groupName].default_lot_sizes[index];
            new_row.symbol =
              loadedProgram.groups[groupName].symbols !== undefined
                ? loadedProgram.groups[groupName].symbols[index]
                : undefined;
            new_row.external_id =
              loadedProgram.groups[groupName].programs_ids[index];
            new_row.group = groupName;
            // this is for the modification object to get which one to send to backend for modification
            if (overallProgram[groupName] === undefined) {
              overallProgram[groupName] = {};
            }
            overallProgram[groupName][
              loadedProgram.groups[groupName].programs_ids[index]
            ] = {};
            overallProgram[groupName][
              loadedProgram.groups[groupName].programs_ids[index]
            ].selected_scheme = value;
            overallProgram[groupName][
              loadedProgram.groups[groupName].programs_ids[index]
            ].default_market_price =
              loadedProgram.groups[groupName].default_market_prices[index];
            overallProgram[groupName][
              loadedProgram.groups[groupName].programs_ids[index]
            ].default_lot_size =
              loadedProgram.groups[groupName].default_lot_sizes[index];
            overallProgram[groupName][
              loadedProgram.groups[groupName].programs_ids[index]
            ].symbol =
              loadedProgram.groups[groupName].symbols !== undefined
                ? loadedProgram.groups[groupName].symbols[index]
                : undefined;
            return new_row;
          }
        );
        const columns = [
          {
            name: "Schemas",
            selector: (row) => {
              const customStyles = {
                position: "sticky",
                zIndex:
                  7831 + initial_z_index - incremental_z_index - (row.id + 1),
                overflow: "visible",
                width: "100%",
              };
              incremental_z_index += 10;
              initial_z_index += 100;
              console.log(row.selected_scheme);
              return (
                <Select
                  id={
                    crypto.randomBytes(4).toString("hex") +
                    "groupschema" +
                    "select" +
                    "row" +
                    row.id
                  }
                  className="form-control"
                  classNamePrefix="select"
                  placeholder={row.selected_scheme.value}
                  name={`groupschemaselectrow${row.id}`}
                  onChange={(e) =>
                    changeModificationsOnProgramField(
                      "schema",
                      row.group,
                      row.external_id,
                      e.value
                    )
                  }
                  options={all_schemes}
                  styles={customStyles}
                />
              );
            },
            grow: 1,
            allowOverflow: true,
          },
          {
            name: "Símbolo",
            selector: (row) => {
              return (
                <Form.Control
                  required
                  id={crypto.randomBytes(4).toString("hex") + row.id + "symbol"}
                  type="text"
                  maxLength="128"
                  placeholder={
                    row.symbol === undefined || row.symbol === "all"
                      ? "todos"
                      : row.symbol
                  }
                  onChange={(e) =>
                    changeModificationsOnProgramField(
                      "symbol",
                      row.group,
                      row.external_id,
                      e.target.value
                    )
                  }
                />
              );
            },
            grow: 1,
          },
          {
            name: "Tamaño de lote",
            selector: (row) => {
              return (
                <Form.Control
                  required
                  id={
                    crypto.randomBytes(4).toString("hex") + row.id + "lotsize"
                  }
                  type="number"
                  step="any"
                  min="0"
                  onChange={(e) =>
                    changeModificationsOnProgramField(
                      "default_lot_size",
                      row.group,
                      row.external_id,
                      e.target.value
                    )
                  }
                  placeholder={row.default_lot_size}
                />
              );
            },
            grow: 1,
          },
          {
            name: "Pago por Rebate",
            selector: (row) => {
              return (
                <Form.Control
                  required
                  id={
                    crypto.randomBytes(4).toString("hex") +
                    row.id +
                    "marketPrice"
                  }
                  type="number"
                  step="any"
                  min="0"
                  onChange={(e) =>
                    changeModificationsOnProgramField(
                      "default_market_price",
                      row.group,
                      row.external_id,
                      e.target.value
                    )
                  }
                  placeholder={row.default_market_price}
                />
              );
            },
            grow: 1,
          },
          {
            name: "Eliminar",
            selector: (row) => {
              if (data.length > 1) {
                return (
                  <Button
                    variant="danger"
                    onClick={(e) => {
                      changeModificationsOnProgramField(
                        "default_market_price",
                        row.group,
                        row.external_id,
                        e.target.value,
                        true
                      );
                    }}
                  >
                    <FontAwesomeIcon icon={faTrashAlt}></FontAwesomeIcon>
                  </Button>
                );
              } else {
                <></>;
              }
            },
          },
        ];
        return (
          <div key={groupName.replace(" ") + "container"}>
            <hr></hr>
            <Form.Group className="mb-4 row text-end">
              <span style={{ fontSize: "1.3rem" }}>
                <Badge bg="primary">{groupName}</Badge>
              </span>
              <div className="col-10 text-center">
                <DataTable
                  key={groupName + "table"}
                  striped
                  highlightOnHover
                  columns={columns}
                  data={data}
                />
              </div>
              <div
                className="col-1 text-center"
                style={{ display: "flex", alignSelf: "end" }}
              >
                <Button
                  variant="secondary"
                  onClick={(e) => {
                    createNewAgreementHandle(groupName);
                  }}
                >
                  <FontAwesomeIcon icon={faPlus}></FontAwesomeIcon>
                </Button>
              </div>
              <div>
                <Button
                  variant="danger"
                  onClick={(e) => {
                    eraseGroupFromAgreements(groupName);
                  }}
                >
                  <FontAwesomeIcon icon={faTimesCircle}></FontAwesomeIcon>
                </Button>
              </div>
            </Form.Group>
          </div>
        );
      });
      // here change to update the new fields
      setOverallPrograms((previousProgram) => {
        if (previousProgram !== null) {
          let newProgram = { ...previousProgram };
          Object.keys(newProgram).forEach((group) => {
            if (overallProgram[group] === undefined) {
              delete newProgram[group];
            } else {
              Object.keys(overallProgram[group]).forEach((programId) => {
                if (
                  newProgram[group][programId] !== undefined &&
                  newProgram[group][programId].modified !== undefined &&
                  newProgram[group][programId].modified === true
                ) {
                  newProgram[group][programId] =
                    previousProgram[group][programId];
                } else {
                  newProgram[group][programId] =
                    overallProgram[group][programId];
                }
              });
            }
          });
          return newProgram;
        } else {
          return overallProgram;
        }
      });
      return result;
    } else {
      return (
        <>
          <Col className="text-center text-md-center">
            <Alert variant={"warning"} style={{ margin: "15px" }}>
              El usuario Afiliado no tiene condiciones y acuerdos{" "}
              <b> por favor crea un programa para este Afiliado</b>
            </Alert>
          </Col>
        </>
      );
    }
  };

  useEffect(() => {
    if (selectedIb !== null && selectedIb?.selectedRows?.length > 0) {
      Ibformik.setValues({
        firstname: selectedIb?.selectedRows[0].name.split(" ")[0],
        lastname: selectedIb?.selectedRows[0].name
          .split(" ")
          .slice(1)
          .join(" "),
        email: selectedIb?.selectedRows[0].email,
        ib_link: selectedIb?.selectedRows[0].ib_link,
        ib_number: selectedIb?.selectedRows[0].ib_number,
        account_number: selectedIb?.selectedRows[0].account_number,
      });
      setSelectedIb(selectedIb?.selectedRows[0]);
      setIsProgramLoading(true);
      getProgram(selectedIb?.selectedRows[0]?.ib_number)
        .then((ProgramData) => {
          setIsProgramLoading(false);
          setLoadedProgram(ProgramData.program);
        })
        .catch((errorProgram) => {
          errorToast(errorProgram);
          setIsProgramLoading(false);
        });
    } else if (
      selectedIb !== null &&
      (selectedIb?.selectedRows?.length === 0 ||
        selectedIb.ib_number === undefined)
    ) {
      setSelectedIb(null);
      setLoadedProgram(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIb]);

  useEffect(() => {
    if (selectedIb !== null) {
      console.log("A");
      setDisabled(IbdataWasChanged(Ibformik?.values, selectedIb));
      console.log(IbdataWasChanged(Ibformik?.values, selectedIb));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Ibformik.values]);

  useEffect(() => {
    console.log("loadedProgram Changed");
    if (loadedProgram !== null) {
      console.log("rendering groups");
      setGroupsData(createGroupsData(changeProgramField));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadedProgram]);

  const deselectAllOtherRows = (row) => {
    if (
      row !== null &&
      row !== undefined &&
      selectedIb !== null &&
      wasSearched === false
    ) {
      return row.ib_number !== selectedIb.ib_number;
    } else {
      return false;
    }
  };

  const searchWasMade = (queried) => {
    setWasSearched(queried);
  };

  const sendIbCreationData = (newIbData) => {
    return new Promise((resolve, reject) => {
      createIb(newIbData)
        .then((successData) => {
          // setSelectedIb({
          //     selectedRows: [successData.ib_created]
          // })
          successToast("Se ha creado Afiliado con exito");
          hideModal();
          resolve(true);
        })
        .catch((errorIb) => {
          errorToast(errorIb);
          reject(false);
        });
    });
  };

  const cancelCreationButtonHandler = () => {
    hideModal();
  };

  const createIbHandle = () => {
    return new Promise((resolve, reject) => {
      showModal({
        title: "Creación de Afiliado",
        body: (
          <CreationIbModal
            handleSumbit={(e) => {
              sendIbCreationData(e)
                .then((success) => {
                  resolve(true);
                })
                .catch((error) => {
                  reject(false);
                });
            }}
          />
        ),
        buttons: (
          <>
            <Button
              key="1"
              variant="default"
              onClick={cancelCreationButtonHandler}
            >
              {"Cancelar"}
            </Button>
          </>
        ),
      });
    });
  };

  const makeReport = () => {
    showModal({
      title: "Generar reportes de todos los afiliados",
      body: (
        <GenerateBatchReportsModal
          closeItselfCallback={cancelCreationButtonHandler}
        />
      ),
      buttons: (
        <>
          <Button
            key="1"
            variant="default"
            onClick={cancelCreationButtonHandler}
          >
            {"Cancelar"}
          </Button>
        </>
      ),
    });
  };

  return (
    <>
      <Row
        className="justify-content-md-center"
        style={{ paddingRight: "2vw", marginTop: "2vw" }}
      >
        <Col xs={12} className="mb-4 d-none d-sm-block">
          <IbsTable
            type="all"
            actions={[
              {
                type: "search",
              },
            ]}
            selectedCallback={setSelectedIb}
            didSearch={searchWasMade}
            deselectedCallback={deselectAllOtherRows}
            deactivateAll
            createIbCallback={createIbHandle}
            generateReport
            createReportCallback={makeReport}
          />
        </Col>
      </Row>
      <Row
        className="justify-content-md-center"
        style={{ paddingRight: "2vw" }}
      >
        <Col xs={12} className="mb-4 d-none d-sm-block">
          <Card border="light" className="shadow-sm">
            {isIbDataLoading && (
              <>
                <LoadingComponent className="d-flex align-items-center justify-content-center"></LoadingComponent>
              </>
            )}
            <Card.Header style={{ marginBottom: "20px" }}>
              <Row>
                {(selectedIb === null ||
                  (selectedIb !== null &&
                    selectedIb?.selectedRows?.length === 0) ||
                  (selectedIb !== null &&
                    selectedIb.ib_number === undefined)) && (
                  <>
                    <Col className="text-center text-md-center">
                      <Alert variant={"info"} style={{ margin: "15px" }}>
                        Selecciona un Afiliado Comercial para{" "}
                        <b>
                          cambiar sus datos, ver o
                          modificar su programa
                        </b>
                      </Alert>
                    </Col>
                  </>
                )}
                {(selectedIb !== null ||
                  (selectedIb !== null &&
                    selectedIb?.selectedRows?.length > 0) ||
                  (selectedIb !== null &&
                    selectedIb.ib_number !== undefined)) && (
                  <>
                    <Col className="text-center">
                      <h4>
                        {" "}
                        <b>
                          Modificar Afiliado Comercial{" "}
                          <FontAwesomeIcon icon={faEdit} />
                        </b>
                      </h4>
                    </Col>
                  </>
                )}
              </Row>
            </Card.Header>
            {(selectedIb !== null ||
              (selectedIb !== null && selectedIb?.selectedRows?.length > 0) ||
              (selectedIb !== null && selectedIb.ib_number !== undefined)) && (
              <Card.Body>
                <Row>
                  <Col xs={12}>
                    <Form
                      className="mt-4 row"
                      onSubmit={Ibformik.handleSubmit}
                      method="put"
                    >
                      <Form.Group className="mb-4 col-4">
                        <Form.Label>Nombre</Form.Label>
                        <CopyField fieldName={"name"} data={Ibformik.values?.firstname} datatitle="Nombre" overlayKey={String(selectedIb.ib_number) + "-name"}>
                        <InputGroup>
                            <Form.Control
                                required
                                id="firstname"
                                type="text"
                                maxLength="128"
                                placeholder={""}
                                className={` ${
                                  Ibformik.touched.firstname &&
                                  Ibformik.errors.firstname
                                    ? "invalid"
                                    : ""
                                } ${
                                  Ibformik.touched.firstname &&
                                  !Ibformik.errors.firstname
                                    ? "valid"
                                    : ""
                                }`}
                                value={Ibformik.values?.firstname}
                                onChange={Ibformik.handleChange}
                                onBlur={Ibformik.handleBlur}
                              />
                        </InputGroup>
                        </CopyField>
                        {Ibformik.touched.firstname &&
                          Ibformik.errors.firstname && (
                            <div
                              style={{ position: "absolute", display: "flex" }}
                            >
                              <small
                                className="invalid-feedback"
                                style={{ display: "inline-block" }}
                              >
                                {" "}
                                <FontAwesomeIcon
                                  icon={faExclamationCircle}
                                />{" "}
                                {Ibformik.errors.firstname}
                              </small>
                            </div>
                          )}
                      </Form.Group>
                      <Form.Group className="mb-4 col-4">
                        <Form.Label>Apellido</Form.Label>
                        <CopyField fieldName={"lastname"} data={Ibformik.values?.lastname} datatitle="Apellido" overlayKey={String(selectedIb.ib_number) + "-lastname"}>
                          <InputGroup>
                            <Form.Control
                              required
                              id="lastname"
                              type="text"
                              maxLength="128"
                              placeholder={""}
                              className={` ${
                                Ibformik.touched.lastname &&
                                Ibformik.errors.lastname
                                  ? "invalid"
                                  : ""
                              } ${
                                Ibformik.touched.lastname &&
                                !Ibformik.errors.lastname
                                  ? "valid"
                                  : ""
                              }`}
                              value={Ibformik.values?.lastname}
                              onChange={Ibformik.handleChange}
                              onBlur={Ibformik.handleBlur}
                            />
                          </InputGroup>
                        </CopyField>
                        {Ibformik.touched.lastname &&
                          Ibformik.errors.lastname && (
                            <div
                              style={{ position: "absolute", display: "flex" }}
                            >
                              <small
                                className="invalid-feedback"
                                style={{ display: "inline-block" }}
                              >
                                {" "}
                                <FontAwesomeIcon
                                  icon={faExclamationCircle}
                                />{" "}
                                {Ibformik.errors.lastname}
                              </small>
                            </div>
                          )}
                      </Form.Group>
                      <Form.Group className="mb-4 col-4">
                        <Form.Label>Correo electrónico</Form.Label>
                        <CopyField fieldName={"email"} data={Ibformik.values?.email} datatitle="Correo Electrónico" overlayKey={String(selectedIb.ib_number) + "-email"}>
                          <InputGroup>
                            <Form.Control
                              required
                              id="email"
                              type="text"
                              maxLength="128"
                              placeholder={""}
                              className={` ${
                                Ibformik.touched.email && Ibformik.errors.email
                                  ? "invalid"
                                  : ""
                              } ${
                                Ibformik.touched.email && !Ibformik.errors.email
                                  ? "valid"
                                  : ""
                              }`}
                              value={Ibformik.values?.email}
                              onChange={Ibformik.handleChange}
                              onBlur={Ibformik.handleBlur}
                            />
                          </InputGroup>
                        </CopyField>
                        {Ibformik.touched.email && Ibformik.errors.email && (
                          <div
                            style={{ position: "absolute", display: "flex" }}
                          >
                            <small
                              className="invalid-feedback"
                              style={{ display: "inline-block" }}
                            >
                              {" "}
                              <FontAwesomeIcon
                                icon={faExclamationCircle}
                              />{" "}
                              {Ibformik.errors.email}
                            </small>
                          </div>
                        )}
                      </Form.Group>
                      <Form.Group className="mb-4 col-4">
                        <Form.Label>Número de cuenta</Form.Label>
                        <CopyField fieldName={"accountnumber"} data={Ibformik.values?.account_number} datatitle="Número de cuenta" overlayKey={String(selectedIb.ib_number) + "-accountnumber"}>
                          <InputGroup>
                            <Form.Control
                              required
                              id="account_number"
                              type="text"
                              maxLength="128"
                              placeholder={""}
                              className={` ${
                                Ibformik.touched.account_number &&
                                Ibformik.errors.account_number
                                  ? "invalid"
                                  : ""
                              } ${
                                Ibformik.touched.account_number &&
                                !Ibformik.errors.account_number
                                  ? "valid"
                                  : ""
                              }`}
                              value={Ibformik.values?.account_number}
                              onChange={Ibformik.handleChange}
                              onBlur={Ibformik.handleBlur}
                            />
                          </InputGroup>
                        </CopyField>
                        {Ibformik.touched.account_number &&
                          Ibformik.errors.account_number && (
                            <div
                              style={{ position: "absolute", display: "flex" }}
                            >
                              <small
                                className="invalid-feedback"
                                style={{ display: "inline-block" }}
                              >
                                {" "}
                                <FontAwesomeIcon
                                  icon={faExclamationCircle}
                                />{" "}
                                {Ibformik.errors.account_number}
                              </small>
                            </div>
                          )}
                      </Form.Group>
                      <Form.Group className="mb-4 col-4">
                        <Form.Label>Número de IB</Form.Label>
                        <CopyField fieldName={"ibnumber"} data={Ibformik.values?.ib_number} datatitle="Número de IB" overlayKey={String(selectedIb.ib_number) + "-ibnumber"}>
                          <InputGroup>
                            <Form.Control
                              required
                              id="ib_number"
                              type="text"
                              maxLength="128"
                              placeholder={""}
                              className={` ${
                                Ibformik.touched.ib_number &&
                                Ibformik.errors.ib_number
                                  ? "invalid"
                                  : ""
                              } ${
                                Ibformik.touched.ib_number &&
                                !Ibformik.errors.ib_number
                                  ? "valid"
                                  : ""
                              }`}
                              value={Ibformik.values?.ib_number}
                              onChange={Ibformik.handleChange}
                              onBlur={Ibformik.handleBlur}
                            />
                          </InputGroup>
                        </CopyField>
                        {Ibformik.touched.ib_number &&
                          Ibformik.errors.ib_number && (
                            <div
                              style={{ position: "absolute", display: "flex" }}
                            >
                              <small
                                className="invalid-feedback"
                                style={{ display: "inline-block" }}
                              >
                                {" "}
                                <FontAwesomeIcon
                                  icon={faExclamationCircle}
                                />{" "}
                                {Ibformik.errors.ib_number}
                              </small>
                            </div>
                          )}
                      </Form.Group>
                      <Form.Group className="mb-4 col-4">
                        <Form.Label>Link de IB</Form.Label>
                        <InputGroup>
                          <Form.Control
                            disabled
                            id="ib_link"
                            type="text"
                            maxLength="128"
                            placeholder={""}
                            className={` ${
                              Ibformik.touched.ib_link &&
                              Ibformik.errors.ib_link
                                ? "invalid"
                                : ""
                            } ${
                              Ibformik.touched.ib_link &&
                              !Ibformik.errors.ib_link
                                ? "valid"
                                : ""
                            }`}
                            value={Ibformik.values?.ib_link}
                            onChange={Ibformik.handleChange}
                            onBlur={Ibformik.handleBlur}
                          />
                        </InputGroup>
                        {Ibformik.touched.ib_link &&
                          Ibformik.errors.ib_link && (
                            <div
                              style={{ position: "absolute", display: "flex" }}
                            >
                              <small
                                className="invalid-feedback"
                                style={{ display: "inline-block" }}
                              >
                                {" "}
                                <FontAwesomeIcon
                                  icon={faExclamationCircle}
                                />{" "}
                                {Ibformik.errors.ib_link}
                              </small>
                            </div>
                          )}
                      </Form.Group>
                      <Form.Group className="mb-4 col-12">
                        <div className="text-center">
                          <Button
                            variant={
                              Object.keys(Ibformik.errors).length > 0 ||
                              disabled
                                ? "primary"
                                : "secondary"
                            }
                            type="submit"
                            className="w-100"
                            disabled={
                              Object.keys(Ibformik.errors).length > 0 ||
                              disabled
                            }
                          >
                            Modificar datos del afiliado
                          </Button>
                        </div>
                      </Form.Group>
                    </Form>
                  </Col>
                </Row>
              </Card.Body>
            )}
          </Card>
        </Col>
      </Row>
      {(selectedIb !== null ||
        (selectedIb !== null && selectedIb?.selectedRows?.length > 0) ||
        (selectedIb !== null && selectedIb.ib_number !== undefined)) &&
        loadedProgram !== null && (
          <Row style={{ paddingRight: "2vw", background: "var(--bs-primary)" }}>
            <Col xs={12} className="mb-4 d-none d-sm-block">
              <Card border="light" className="shadow-sm">
                {isProgramLoading && (
                  <>
                    <LoadingComponent className="d-flex align-items-center justify-content-center"></LoadingComponent>
                  </>
                )}
                <Card.Header style={{ marginBottom: "20px" }}>
                  <Row>
                    <Col className="text-center">
                      {overallPrograms !== null ? (
                        <h4>
                          {" "}
                          <b>
                            Modificar condiciones y acuerdos{" "}
                            <FontAwesomeIcon icon={faEdit} />
                          </b>
                        </h4>
                      ) : (
                        <div className="text-center">
                          <h4>
                            {" "}
                            <b>
                              Crear condiciones y acuerdos{" "}
                              <FontAwesomeIcon icon={faFile} />
                            </b>
                          </h4>
                        </div>
                      )}
                    </Col>
                  </Row>
                </Card.Header>
                {(selectedIb !== null ||
                  (selectedIb !== null &&
                    selectedIb?.selectedRows?.length > 0) ||
                  (selectedIb !== null &&
                    selectedIb.ib_number !== undefined)) &&
                  loadedProgram !== null &&
                  groupsData !== null && (
                    <Card.Body>
                      <Row>
                        <Col xs={12}>
                          <Form
                            id="programForm"
                            className="mt-4 row"
                            onSubmit={Ibformik.handleSubmit}
                            method="put"
                          >
                            {overallPrograms !== null && (
                              <Form.Label>Grupos</Form.Label>
                            )}
                            {groupsData}
                            <Form.Group className="mb-4 col-12">
                              {overallPrograms !== null ? (
                                <div className="text-center">
                                  <Button
                                    variant="primary"
                                    onClick={(e) =>
                                      saveModifiedProgramForGroup(
                                        overallPrograms,
                                        erasedGroups
                                      )
                                    }
                                    disabled={
                                      Object.values(overallPrograms).every(
                                        (groupObject) =>
                                          Object.values(groupObject).every(
                                            (Element) =>
                                              Element.modified === false ||
                                              Element.modified === undefined
                                          )
                                      ) && erasedGroups.length === 0
                                    }
                                    type="submit"
                                    className="w-100"
                                  >
                                    Modificar datos de condiciones y acuerdos
                                  </Button>
                                </div>
                              ) : (
                                <div className="text-center">
                                  <Button
                                    variant="secondary"
                                    onClick={(e) => createProgramHandle()}
                                    type="button"
                                    className="w-100"
                                  >
                                    Crear Condiciones y Acuerdos
                                  </Button>
                                </div>
                              )}
                            </Form.Group>
                          </Form>
                        </Col>
                      </Row>
                    </Card.Body>
                  )}
              </Card>
            </Col>
          </Row>
        )}
    </>
  );
}

export default IbPage;
